var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "183.223 -803.69 591.237 619.69",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478.46-184q-123.84 0-209.92-86.08-86.08-86.07-85.31-209.92h30.46q2.31 108.23 79.04 186.12Q369.46-216 478.46-216t186.5-77.5 77.5-186.5-77.5-186.5-186.5-77.5q-55.08 0-102.24 19.83t-83.84 54.63h96.24v32H222.46v-166.15h32v131.54q41.39-46.93 98.73-75.39Q410.54-776 478.46-776q61.54 0 115.37 23.14 53.82 23.14 94.09 63.4 40.26 40.27 63.4 94.1 23.14 53.82 23.14 115.36t-23.14 115.36q-23.14 53.83-63.4 94.1-40.27 40.26-94.09 63.4Q540-184 478.46-184m116.16-173.85L464.77-487.69V-672h32v169.69l121.15 121.16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.b71d9ae14d485154cd7e0181e142376b.svg";
export { ForwardRef as ReactComponent };